import Bowser from 'bowser'
import each from 'lodash/each'

const maxBlur = 15

function Blurrable() {
  return {
    init(el) {
      this.blurrable = el

      const browser = Bowser.getParser(window.navigator.userAgent)
      if (browser.getBrowserName() === 'Internet Explorer') {
        return
      }

      this.handleScroll()
      this.bound_handleScroll = this.handleScroll.bind(this)

      this.mqHandler = (mql) => {
        this.handleMediaQueryChange(mql)
      }

      window.APP.mq.large.addListener(this.mqHandler)
      this.handleMediaQueryChange(window.APP.mq.large)
    },
    handleMediaQueryChange(mql) {
      if (mql.matches) {
        window.addEventListener('scroll', this.bound_handleScroll)
      } else {
        window.removeEventListener('scroll', this.bound_handleScroll)
        this.reset()
      }
    },
    reset() {
      if (!this.blurrable) {
        return
      }
      this.blurrable.style.filter = 'none'
    },
    handleScroll() {
      if (!this.blurrable) {
        return
      }
      const scrollY = window.pageYOffset
      let blur = scrollY / 100
      if (blur > maxBlur) {
        blur = maxBlur
      }
      this.blurrable.style.filter = `blur(${blur}px)`
    },
    destroy() {
      window.APP.mq.large.removeListener(this.mqHandler)
      window.removeEventListener('scroll', this.bound_handleScroll)
      this.reset()
    },
  }
}

const blurrables = []

function setupBlurrable(el) {
  const blurrable = new Blurrable()
  blurrable.init(el)
  blurrables.push(blurrable)
}

function setupBlurrables(container) {
  if (!container) {
    return
  }

  // Initialize existing elements:

  const existingEls = container.querySelectorAll('.blurrable')
  if (existingEls.length) {
    each(existingEls, (el) => {
      setupBlurrable(el)
    })
  }

  // Observe new elements:

  const observer = new MutationObserver((mutations) => {
    each(mutations, (mutation) => {
      each(mutation.addedNodes, (node) => {
        if (node.nodeType !== 1) {
          return
        }

        const els = node.querySelectorAll('.blurrable')
        if (!els.length) {
          return
        }

        each(els, (el) => {
          setupBlurrable(el)
        })
      })
    })
  })

  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  })
}

function destroyBlurrables() {
  blurrables.forEach((blurrable) => blurrable.destroy())
}

export { setupBlurrables, destroyBlurrables }
